import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import Select from "react-select";
import { ReactSelectClassName } from "components/Shared/MSelect";
import {updateHeader, clearHeader} from "actions/layout";

const defaultButtonsProps = {
    name: "placeholder",
    onClick: null,
    disabled: false,
    primary: true,
    raised: true,
    Control: null,
};

class MHeader extends React.Component {

    constructor(props) {
        super(props);
        this.constructButtons = this.constructButtons.bind(this);
        this.renderInlineButtons = this.renderInlineButtons.bind(this);
        this.renderDropdownButtons = this.renderDropdownButtons.bind(this);
        this.getClassName = this.getClassName.bind(this);
    }   

    constructButtons() {
        const {buttons} = this.props.headerDefinitions;
        return (buttons || []).map((button) => {
            return {
                ...defaultButtonsProps,
                ...button,
            };
        });
    }

    renderInlineButtons(buttons) {
        return buttons.map(({name, onClick, disabled, raised, Control}, index) => {
            return Control ?? (
                <Button
                    key={index}
                    onClick={onClick}
                    disabled={disabled}
                    variant={raised ? "contained" : "text"}
                    sx={{
                        backgroundColor: "var(--header-button-bg-color)",
                        "&:hover": {
                            backgroundColor: "var(--header-button-bg-color)",
                            filter: "brightness(0.9)",
                        },
                    }}
                >{name}</Button>
            );
        });
    }

    renderDropdownButtons(buttons) {
        const {dropdownTitle} = this.props.headerDefinitions;
        return (
            <Select
                className={ReactSelectClassName}
                placeholder={dropdownTitle || "Actions"}
                classNamePrefix="react-select"
                isSearchable={false}
                value={dropdownTitle}
                options={buttons.map(({name, onClick}) => { return {
                    label: name,
                    value: onClick,
                 };})}
                onChange={(selected) => {selected.value();}}
            />
        );
    }

    getClassName(defaultClassName) {
        if(this.props.headerDefinitions.buttons.length === 1)
            return `${defaultClassName} single-item`;
        return defaultClassName;
    }

    render() {
        const buttons = this.constructButtons();
        if(buttons.length === 0) {
            return null;
        }

        return (
            <React.Fragment>
                <div className={this.getClassName("header-inline-btns")}>
                    {this.renderInlineButtons(buttons)}
                </div>
                <div className={this.getClassName("header-dropdown-btns")}>
                    {this.renderDropdownButtons(buttons)}
                </div>
            </React.Fragment>
        );
    }
}

MHeader.defaultProps = {
    headerDefinitions: {
        buttons: [],
    },
};

MHeader.propTypes = {
    ///Pure
    pathname: PropTypes.string,

    //Router
    location: PropTypes.string,

    ///Redux State
    headerDefinitions: PropTypes.object.isRequired,

    ///Redux Actions
    updateHeader: PropTypes.func.isRequired,
    clearHeader: PropTypes.func.isRequired,
    useDispatch: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
    headerDefinitions: state.layout.header,
});

const mapDispatchToProps = dispatch => ({
    updateHeader(headerDefinitions) {
        dispatch(updateHeader(headerDefinitions));
    },
    clearHeader() {
        dispatch(clearHeader());
    },
    useDispatch() {
        return dispatch;
    },
  });

export default connect(mapStateToProps, mapDispatchToProps)(MHeader);